import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';

import {
  setProductSKU as setProductSKUAction,
  toggleAllShades as toggleAllShadesAction,
} from '../modules';

const ProductSwatchContainer = ({
  childComponent: ChildComponent,
  ...props
}) => <ChildComponent {...props} />;

const mapStateToProps = (state) => {
  const swatches = R.path(['content', 'productSwatch', 'swatches'])(state);
  const selectedSKU = R.path(['productSwatch', 'selectedSKU'])(state);
  const isOpen = R.path(['productSwatch', 'isOpen'])(state);

  const selectedSwatch = R.find(({ sku }) => sku === selectedSKU)(swatches);

  return {
    swatches,
    selectedSKU,
    isOpen,
    selectedItemName: R.prop('itemName')(selectedSwatch),
    selectedItemUnits: R.prop('units')(selectedSwatch),
    selectedItemSize: R.prop('skuSize')(selectedSwatch),
  };
};

const mapDispatchToProps = (dispatch) => ({
  setProductSKU: (productId) => dispatch(setProductSKUAction(productId)),
  toggleAllShades: () => dispatch(toggleAllShadesAction()),
});

ProductSwatchContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductSwatchContainer);
